import { getStatesForCountry } from '@yoweb/utils/intl/address';
import { Select } from '@yoweb/ui/components/form';
import { useTranslation } from '@yoweb/next-i18next';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import type { SelectProps } from '@yoweb/ui/components/form/Select';

type StatePickerProps = Omit<SelectProps, 'options'>;

/**
 * Picker of states.
 * Supports Japan or US states depending on the current locale.
 */
export const StatePicker = ({ ...props }: StatePickerProps) => {
  const { t } = useTranslation('states');
  const { country } = useIntlMeta();

  return <Select {...props} options={getStatesForCountry(country, t)} />;
};

export default StatePicker;
